/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import { put, call, takeEvery } from "redux-saga/effects";
import jwt_decode from "jwt-decode";
import { Auth /* setAuthToken */ } from "../api/agent";
import handleFailedAuth from "../helpers/handleExpiredToken";

import showToast from "../helpers/toastNotification";

import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  SIGNUP_REQUEST,
  SIGNUP_SUCCESS,
  SIGNUP_FAILURE,
  GOOGLE_LOGIN_REQUEST,
  GOOGLE_LOADER_START,
  GOOGLE_LOADER_END,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  FORGOT_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  RESET_PASSWORD_REQUEST,
  GET_USER_DETAIL,
  GET_USER_DETAIL_SUCCESS,
  GET_USER_DETAIL_FAILURE,
  UPDATE_USER_DETAIL,
  UPDATE_USER_DETAIL_SUCCESS,
  UPDATE_USER_DETAIL_FAILURE,
  UPDATE_USER_PASSWORD,
  UPDATE_USER_PASSWORD_SUCCESS,
  UPDATE_USER_PASSWORD_FAILURE,
  SET_CURRENT_USER,
  ACTIVATE_USER,
  ACTIVATE_USER_SUCCESS,
  ACTIVATE_USER_FAILURE,
  SAVE_INVESTOR_PROFILE,
  SAVE_INVESTOR_PROFILE_SUCCESS,
  SAVE_INVESTOR_PROFILE_FAILURE,
  UPDATE_INVESTOR_PROFILE,
  UPDATE_INVESTOR_PROFILE_SUCCESS,
  UPDATE_INVESTOR_PROFILE_FAILURE,
  SAVE_FILTER,
  SAVE_FILTER_SUCCESS,
  SAVE_FILTER_FAILURE
} from "../actions/auth/authActionTypes";

function* login(userData) {
  try {
    const payload = yield call(Auth.login, userData.payload);
    // setAuthToken(payload.token)
    localStorage.setItem("token", payload.token);
    const decoded = jwt_decode(payload.token);
    yield put({ type: LOGIN_SUCCESS, payload: decoded });
  } catch (err) {
    /*
     *TODO:to check whether it'a server error or validation error
     *and put the action respectively
     */
    const errResp = err.response.body;
    yield put({ type: LOGIN_FAILURE, errResp });
  }
}

function* activateUser(userData) {
  try {
    const payload = yield call(Auth.activateUser, userData.payload);
    // setAuthToken(payload.token)
    localStorage.setItem("token", payload.token);
    const decoded = jwt_decode(payload.token);
    yield put({ type: ACTIVATE_USER_SUCCESS, payload: decoded });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: ACTIVATE_USER_FAILURE, errResp });
  }
}

export function* watchActivateUser() {
  yield takeEvery(ACTIVATE_USER, activateUser);
}

export function* watchLogin() {
  yield takeEvery(LOGIN_REQUEST, login);
}

function* signup(userData) {
  try {
    const payload = yield call(Auth.signup, userData.payload);
    localStorage.setItem("token", payload.token);
    const decoded = jwt_decode(payload.token);
    yield put({ type: SIGNUP_SUCCESS, payload: decoded });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: SIGNUP_FAILURE, errResp });
  }
}

export function* watchSignup() {
  yield takeEvery(SIGNUP_REQUEST, signup);
}

function* googleLogin(action) {
  try {
    //to show loader
    yield put({ type: GOOGLE_LOADER_START });
    const payload = yield call(Auth.googleLogin, action.payload);
    // setAuthToken(payload.token)
    localStorage.setItem("token", payload.token);
    const decoded = jwt_decode(payload.token);
    yield put({ type: GOOGLE_LOADER_END });
    yield put({ type: LOGIN_SUCCESS, payload: decoded });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: GOOGLE_LOADER_END });

    yield put({ type: LOGIN_FAILURE, errResp });
  }
}

export function* watchGoogleLogin() {
  yield takeEvery(GOOGLE_LOGIN_REQUEST, googleLogin);
}

export function* forgotpassword(userData) {
  try {
    const payload = yield call(Auth.forgotpassword, userData.payload);
    yield put({ type: FORGOT_PASSWORD_SUCCESS, payload });
  } catch (error) {
    const err = error.response.body;
    yield put({ type: FORGOT_PASSWORD_FAILURE, err });
  }
}

export function* watchForgotPassword() {
  yield takeEvery(FORGOT_PASSWORD_REQUEST, forgotpassword);
}

export function* resetpassword(userData) {
  try {
    const payload = yield call(Auth.resetpassword, userData.payload);
    yield put({ type: RESET_PASSWORD_SUCCESS, payload });
  } catch (error) {
    const err = error.response.body;
    yield put({ type: RESET_PASSWORD_FAILURE, err });
  }
}

export function* watchResetPassword() {
  yield takeEvery(RESET_PASSWORD_REQUEST, resetpassword);
}

export function* getUserDetail() {
  try {
    const payload = yield call(Auth.userDetail);
    yield put({ type: GET_USER_DETAIL_SUCCESS, payload });
  } catch (error) {
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    const err = error.response.body;
    yield put({ type: GET_USER_DETAIL_FAILURE, err });
  }
}

export function* watchGetUserDetail() {
  yield takeEvery(GET_USER_DETAIL, getUserDetail);
}

export function* updateUserDetail(userData) {
  try {
    const payload = yield call(Auth.updateUserDetail, userData.payload);
    yield put({ type: UPDATE_USER_DETAIL_SUCCESS, payload });
    yield put({ type: SET_CURRENT_USER, payload: payload.data });
    showToast("s", "Updated successfully");
  } catch (error) {
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    const err = error.response.body;
    showToast("e", err.message);

    yield put({ type: UPDATE_USER_DETAIL_FAILURE, err });
  }
}

export function* watchUpdateUserDetail() {
  yield takeEvery(UPDATE_USER_DETAIL, updateUserDetail);
}

function* updatePassword(userData) {
  try {
    const payload = yield call(Auth.updateUserDetail, userData.payload);
    yield put({ type: UPDATE_USER_PASSWORD_SUCCESS, payload });
    showToast("s", "Updated successfully");
  } catch (error) {
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    const err = error.response.body;
    showToast("e", err.message);
    yield put({ type: UPDATE_USER_PASSWORD_FAILURE, err });
  }
}

export function* watchUpdatePassword() {
  yield takeEvery(UPDATE_USER_PASSWORD, updatePassword);
}

function* saveInvestorProfile(userData) {
  try {
    const payload = yield call(Auth.saveInvestorProfile, userData.payload);
    yield put({ type: SAVE_INVESTOR_PROFILE_SUCCESS, payload });
    showToast("s", "Updated successfully");
  } catch (error) {
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    const err = error.response.body;
    showToast("e", err.message);
    yield put({ type: SAVE_INVESTOR_PROFILE_FAILURE, err });
  }
}

export function* watchInvestorProfile() {
  yield takeEvery(SAVE_INVESTOR_PROFILE, saveInvestorProfile);
}

function* updateInvestorProfile(userData) {
  try {
    const payload = yield call(Auth.updateInvestorProfile, userData.payload);
    yield put({ type: UPDATE_INVESTOR_PROFILE_SUCCESS, payload });
    showToast("s", "Updated successfully");
  } catch (error) {
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    const err = error.response.body;
    showToast("e", err.message);
    yield put({ type: UPDATE_INVESTOR_PROFILE_FAILURE, err });
  }
}

export function* watchUpdateInvestorProfile() {
  yield takeEvery(UPDATE_INVESTOR_PROFILE, updateInvestorProfile);
}

function* saveFilter(data) {
  try {
    const payload = yield call(Auth.saveFilter, data.payload);
    yield put({ type: SAVE_FILTER_SUCCESS, payload });
    showToast("s", "Filter saved successfully");
  } catch (error) {
    const err = error.response.body;
    showToast("e", err.message);
    yield put({ type: SAVE_FILTER_FAILURE, err });
  }
}

export function* watchSaveFilter() {
  yield takeEvery(SAVE_FILTER, saveFilter);
}
